import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
var i = {
	12: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 12 12",
			fill: "none",
			...e,
			children: [/* @__PURE__ */ n("circle", {
				cx: 6.00002,
				cy: 5.99999,
				r: 4.25625,
				stroke: "#DE9145",
				strokeWidth: .9375
			}), /* @__PURE__ */ n("path", {
				d: "M5.99998 3.60001C6.37872 3.60001 6.75209 3.68964 7.08955 3.86159C7.42702 4.03354 7.719 4.28291 7.94162 4.58932C8.16424 4.89573 8.31118 5.25048 8.37043 5.62456C8.42968 5.99865 8.39955 6.38144 8.28251 6.74165L5.99998 6.00001V3.60001Z",
				fill: "#DE9145"
			})]
		}),
		width: 12,
		height: 12
	},
	16: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 16 16",
			fill: "none",
			...e,
			children: [/* @__PURE__ */ n("circle", {
				cx: 8.00001,
				cy: 8.00001,
				r: 5.675,
				stroke: "#DE9145",
				strokeWidth: 1.25
			}), /* @__PURE__ */ n("path", {
				d: "M7.99999 4.79999C8.50498 4.79999 9.00281 4.9195 9.45276 5.14877C9.90271 5.37803 10.292 5.71053 10.5888 6.11907C10.8857 6.52762 11.0816 7.00062 11.1606 7.4994C11.2396 7.99817 11.1994 8.50857 11.0434 8.98884L7.99999 7.99999L7.99999 4.79999Z",
				fill: "#DE9145"
			})]
		}),
		width: 16,
		height: 16
	},
	20: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 20 20",
			fill: "none",
			...e,
			children: [/* @__PURE__ */ n("circle", {
				cx: 10,
				cy: 10,
				r: 7.09375,
				stroke: "#DE9145",
				strokeWidth: 1.5625
			}), /* @__PURE__ */ n("path", {
				d: "M10 6C10.6312 6 11.2535 6.1494 11.816 6.43597C12.3784 6.72255 12.865 7.13817 13.2361 7.64886C13.6071 8.15954 13.852 8.75079 13.9508 9.37426C14.0495 9.99773 13.9993 10.6357 13.8042 11.2361L10 10L10 6Z",
				fill: "#DE9145"
			})]
		}),
		width: 20,
		height: 20
	},
	24: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 24 24",
			fill: "none",
			...e,
			children: [/* @__PURE__ */ n("circle", {
				cx: 12,
				cy: 12,
				r: 8.5125,
				stroke: "#DE9145",
				strokeWidth: 1.875
			}), /* @__PURE__ */ n("path", {
				d: "M12 7.20001C12.7575 7.20001 13.5042 7.37929 14.1792 7.72318C14.8541 8.06707 15.4381 8.56582 15.8833 9.17864C16.3285 9.79147 16.6224 10.501 16.7409 11.2491C16.8594 11.9973 16.7992 12.7629 16.5651 13.4833L12 12V7.20001Z",
				fill: "#DE9145"
			})]
		}),
		width: 24,
		height: 24
	}
}, a = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: i[t],
	...r
});
//#endregion
export { a as StatusInProgressIcon };
